import script from "./TableEmptyData.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableEmptyData.vue?vue&type=script&setup=true&lang=ts"

import "./TableEmptyData.vue?vue&type=style&index=0&id=b4f80286&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4f80286"]])

export default __exports__